import * as React from 'react';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { ErrorWrapper } from '../uiComponents/ErrorWrapper';

export interface IngenInstitutionerProps {
}

export default class IngenInstitutioner extends React.Component<IngenInstitutionerProps, any> {
    render() {
        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <ErrorWrapper header='Din bruger kan ikke logge på'>
                            <p>
                                Din bruger er ikke rigtig sat op i Uni Logins brugeradministration.
                                        </p>

                            <p>
                                Kontakt din Uni Login brugeradministrator og få din bruger "identificeret" (få tilknyttet cpr nummer).
                                        </p>
                        </ErrorWrapper>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/IngenInstitutioner.tsx